import { activateLanguage } from "../features/store-language/i18n.ts";

export type StoreAgencySession = {
  userId: string;
  salesAgencyId: string;
  membershipId: string;
  role: string;
  displayName: string;
  mobile?: string;
  email?: string;
  agencyTitle?: string;
  preferredLanguage?: string;
  canViewInventory?: boolean;
};

let current: StoreAgencySession | null = null;
let revision = 0;
const listeners = new Set<() => void>();

export function setAgencySession(session: StoreAgencySession | null): void {
  if (session?.preferredLanguage) {
    activateLanguage(session.preferredLanguage);
  }
  const changed = current?.userId !== session?.userId || current?.membershipId !== session?.membershipId || current?.role !== session?.role || current?.salesAgencyId !== session?.salesAgencyId
    || current?.canViewInventory !== session?.canViewInventory;
  if (changed) revision++;
  current = session;
  if (changed) listeners.forEach(function (listener) { listener(); });
}

export function subscribeAgencySession(listener: () => void): () => void {
  listeners.add(listener);
  return function () { listeners.delete(listener); };
}

export function getAgencySession(): StoreAgencySession | null {
  return current;
}

export function agencySessionKey(): string | null {
  return current ? `${current.userId}:${current.membershipId}:${revision}` : null;
}

export function canViewAgencyInventory(): boolean {
  return current?.canViewInventory === true;
}

export function isAgencyManager(): boolean {
  return current?.role === "Manager";
}

export function canWriteAgencyCommerce(): boolean {
  return current !== null;
}

export function canChangeOrderStatus(): boolean {
  return current?.role === "Manager" || current?.role === "CompanySalesAgent";
}

export function isCompanySalesAgent(): boolean {
  return current?.role === "CompanySalesAgent";
}
